import Api from "./xo_service";

export default {
  postPlayer(body) {
    return Api().post("/players", body);
  },
  getPlayer(id) {
    return Api().get(`/players/${id}/accounts`);
  },
  addAccount(body) {
    return Api().post("/players/accounts", body);
  },
  deleteAccount(id) {
    return Api().post(`/players/accounts/${id}/disable`);
  },
  getRank(id) {
    return Api().get(`/players/${id}/player`);
  },
  confirmPlayer(termId) {
    return Api().post(`/confirmRegister/${termId}`);
  },
};
